import React from 'react';
import PropTypes from 'prop-types';
import { trafficColorsClass } from 'utils/general';

class Arc extends React.Component {
  componentDidMount() {
    this.setSvg(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setSvg(nextProps);
  }

  setSvg(props) {
    const { data, width, height, radioDifference, max, id, showAverage = true } = props;
    const w = width || 400;
    const h = height || 400;
    const r = height / 2;
    const ir = r - radioDifference;
    const gapValue = max - data.value;
    const arcData = [data].slice().concat({ label: 'gap', value: gapValue });
    const tooltip = d3.selectAll('.c-tooltip-graph');

    // Remove svg to avoid append
    const svgEl = d3.select(`#${id} svg`)[0];
    svgEl[0] && svgEl[0].remove();
    const svg = d3.select(`#${this.props.id}`).append('svg')
      .data([arcData])
        .attr('width', w)
        .attr('height', h)
      .append('g')
        .attr('transform', `translate(${r}, ${r})`);
    if (!data || !data.value || isNaN(data.value)) return;
    const arc = d3.svg.arc()
      .outerRadius(r)
      .innerRadius(ir);

    const pie = d3.layout.pie()
      .sort(null)
      .value((d) => d.value / 2)
      .startAngle(0)
      .endAngle(2 * Math.PI);

    const arcs = svg.selectAll('.slice')
      .data(pie)
      .enter()
      .append('g')
        .attr('class', 'slice');

    arcs.append('path')
      .attr('class', (d, i) => i === 0 ? trafficColorsClass(d.data.value) : '-gap')
      .attr('d', arc)
      .on('mousemove', (d) => {
        d.data.label !== 'gap' &&
          tooltip
            .style('left', `${d3.event.pageX - 50}px`)
            .style('top', `${d3.event.pageY - 70}px`)
            .style('display', 'flex')
            .html(`<span class="title">${d.data.label}</span><span class="value">${d.data.value}</span>`);
      })
      .on('mouseout', () => tooltip.style('display', 'none'));

    // Average
    const pi = Math.PI;
    const angleX = (+data.avg * (2 * pi)) / 100;
    const angleY = 180 - 90 - angleX;
    const cx = Math.sin(angleX) * (ir + (radioDifference / 2));
    const cy = Math.cos(angleX) * (ir + (radioDifference / 2));
    if (showAverage) {
      svg.append('circle')
      .attr('class', data.avg !== null ? 'dot' : 'dot -no-data')
      .attr('cx', angleX < pi ? cx : -cx)
      .attr('cy', angleY < (pi / 2) || angleY < pi ? cy : -cy)
      .attr('r', (radioDifference / 2) - 1)
      .attr('fill', '#fff')
      .on('mousemove', () => {
        tooltip
          .style('left', `${d3.event.pageX - 50}px`)
          .style('top', `${d3.event.pageY - 70}px`)
          .style('display', 'flex')
          .html(`<span class="title">Average</span><span class="value">${data.avg || 'Not available'}</span>`);
      })
      .on('mouseout', () => tooltip.style('display', 'none'));
    }
  }

  render() {
    return (
      <div className="c-arc">
        <div id={this.props.id} className="arc"></div>
        {this.props.includeTitle && <h3 className="rank">
          <span>{this.props.data.label}</span><span><span className="value">{this.props.data.value}</span>/100</span>
        </h3>}
      </div>
    );
  }
}

Arc.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  max: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  radioDifference: PropTypes.number,
  includeTitle: PropTypes.bool
};

export default Arc;



// WEBPACK FOOTER //
// ./app/components/common/charts/Arc.jsx